import { cn } from '@realtyfeed/utils';
import { ComponentSpinner } from './Spinner';

type LoadingDataProps = {
  loadingLabel?: string;
  wrapperClassName?: string;
  hideLabel?: boolean;
};

export function LoadingData({ loadingLabel, wrapperClassName, hideLabel }: LoadingDataProps) {
  return (
    <div className={cn('py-8', wrapperClassName)}>
      <ComponentSpinner />
      {!hideLabel && (
        <p className="mt-4 text-center text-sm font-bold text-slate-700 dark:text-slate-300">
          {loadingLabel ?? 'Loading...'}
        </p>
      )}
    </div>
  );
}
